











import {Component, Mixins} from 'vue-property-decorator';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';

@Component
export default class LogoComponent extends Mixins(ResponsiveMixin) {
  private mobileWidth = 44 + 'px';
  private mobileHeight = 44 + 'px';
  private mobileSrc = require('@/assets/images/ic_launcher.png');

  private width = 212 + 'px';
  private height = 44 + 'px';
  private src = require('@/assets/images/logo.png');
}
